// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2ffdd1ef","455":"f0657be4"}[chunkId] + ".chunk.js";
};